var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"color":_vm.getColor,"disabled":(!_vm.isDoctorRecord && _vm.time.disable) || !_vm.time.schedule},on:{"click":_vm.toggleTime}},'v-btn',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.time.time)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }